var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('current-acounts'),_c('nav-component'),_c('clients'),_c('payment-plan'),_c('sellers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }